var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rendered)?_c('div',[_c('TranslatedText',{attrs:{"labels":_vm.element.labels,"default":_vm.element.name}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }